
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.944 8.11h.973a.973.973 0 000-1.944h-.973a.972.972 0 100 1.945zm0 3.89h.973a.973.973 0 000-1.945h-.973a.972.972 0 000 1.945zm-4.86-3.89h.972a.972.972 0 000-1.944h-.973a.972.972 0 000 1.945zm0 3.89h.972a.972.972 0 000-1.945h-.973a.972.972 0 000 1.945zm11.666 7.777h-.972V3.25a.972.972 0 00-.972-.973H5.194a.972.972 0 00-.972.973v16.527H3.25a.972.972 0 000 1.945h17.5a.972.972 0 100-1.945zm-7.778 0h-1.944v-3.889h1.944v3.89zm4.861 0h-2.916v-4.86a.972.972 0 00-.973-.973h-3.888a.972.972 0 00-.973.972v4.861H6.167V4.222h11.666v15.555z","fill":"currentColor"}})])
          )
        }
      }
    